// Klaviyo SMS sign-up trigger (added by EnidS 06-13-25)
function triggerForm(id) {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', id]); 
}

if (typeof Shopify === "undefined") {
	window.Shopify = {}
}
if (typeof Shopify.getCart === "undefined") {
	Shopify.getCart = function (callback, cart) {
		if (!cart) {
			// Use fetch API instead of jQuery.getJSON
			return fetch("/cart.js")
				.then(response => response.json())
				.then(cart => {
					if (typeof callback === "function") {
						callback(cart)
					} else {
						Shopify.onCartUpdate(cart)
					}
					return cart
				})
				.catch(error => {
					console.error("Error fetching cart:", error)
					if (typeof callback === "function") {
						callback(null)
					}
				})
		} else {
			if (typeof callback === "function") {
				callback(cart)
			} else if (typeof Shopify.onCartUpdate === "function") {
				Shopify.onCartUpdate(cart)
			}
		}
	}
}

window.theme = window.theme || {}

theme.config = {
	mqlSmall: false,
	mediaQuerySmall: "screen and (max-width: 749px)",
	isTouch:
		"ontouchstart" in window ||
		(window.DocumentTouch && window.document instanceof DocumentTouch) ||
		window.navigator.maxTouchPoints ||
		window.navigator.msMaxTouchPoints
			? true
			: false,
	rtl: document.documentElement.getAttribute("dir") === "rtl" ? true : false,
}

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
	const threshold = options.threshold ? options.threshold : 0

	const observer = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					if (typeof options.callback === "function") {
						options.callback()
						observer.unobserve(entry.target)
					}
				}
			})
		},
		{ rootMargin: `0px 0px ${threshold}px 0px` }
	)

	observer.observe(options.element)
}

;(function () {
	// Trigger events when going between breakpoints
	const mql = window.matchMedia(theme.config.mediaQuerySmall)
	theme.config.mqlSmall = mql.matches
	mql.onchange = e => {
		if (e.matches) {
			theme.config.mqlSmall = true
			document.dispatchEvent(new CustomEvent("matchSmall"))
		} else {
			theme.config.mqlSmall = false
			document.dispatchEvent(new CustomEvent("unmatchSmall"))
		}
	}

	// Page transition
	window.addEventListener("beforeunload", () => {
		document.body.classList.add("unloading")
	})
	window.addEventListener("DOMContentLoaded", () => {
		document.body.classList.add("loaded")
	})
	window.addEventListener("pageshow", event => {
		// Removes unload class when returning to page via history
		if (event.persisted) {
			document.body.classList.remove("unloading")
		}
	})

	// Viewport height
	function viewportHeight() {
		const platform = navigator?.userAgentData?.platform || navigator?.platform
		if (
			/iPad|iPhone|iPod/.test(platform) ||
			(platform === "MacIntel" && navigator.maxTouchPoints > 1)
		) {
			document.documentElement.style.setProperty(
				"--viewport-height",
				`${window.innerHeight}px`
			)
		}
		setHeaderHeight()
	}
	window.addEventListener("resize", viewportHeight)
	window.addEventListener("DOMContentLoaded", viewportHeight)

	if (document.body.getAttribute("data-page-rendering") !== null) {
		// Improve initial load time by skipping the rendering of offscreen content
		const observer = new IntersectionObserver(
			(entries, _observer) => {
				entries.forEach(entry => {
					const el = entry.target
					// Not currently in intersection area.
					if (entry.intersectionRatio == 0) {
						return
					}
					// Trigger rendering for elements within scroll area that haven't already been marked.
					if (!el.markedVisible) {
						el.attributeStyleMap &&
							el.attributeStyleMap.set("content-visibility", "visible")
						el.markedVisible = true
					}
				})
			},
			// Set a rendering 50px above and 100px below the main scroll area.
			{ rootMargin: "50px 0px 100px 0px" }
		)
		const sections = document.querySelectorAll(".shopify-section + .shopify-section")
		sections.forEach(section => {
			observer.observe(section)
		})
	}

	/*
  // Delay JavaScript until user interaction
  const loadScriptsTimer = setTimeout(loadScripts, 5000);
  const userInteractionEvents = ["mouseover", "mousemove", "keydown", "touchstart", "touchend", "touchmove", "wheel"];
  userInteractionEvents.forEach(function(event) {
    window.addEventListener(event, triggerScriptLoader, {
      passive: !0
    });
  });
  function triggerScriptLoader() {
    loadScripts();
    clearTimeout(loadScriptsTimer);
    userInteractionEvents.forEach(function(event) {
      window.removeEventListener(event, triggerScriptLoader, {
        passive: !0
      });
    });
  }
  function loadScripts() {
    document.querySelectorAll("script[data-type='lazy']").forEach(function(script) {
      script.setAttribute("src", script.getAttribute("data-src"));
    });
  }
  */
})()

// Prevent vertical scroll while using flickity sliders
;(function () {
	var e = !1
	var t

	document.body.addEventListener("touchstart", function (i) {
		if (!i.target.closest(".flickity-slider")) {
			return (e = !1)
		}
		e = !0
		t = {
			x: i.touches[0].pageX,
			y: i.touches[0].pageY,
		}
	})

	document.body.addEventListener(
		"touchmove",
		function (i) {
			if (e && i.cancelable) {
				var n = {
					x: i.touches[0].pageX - t.x,
					y: i.touches[0].pageY - t.y,
				}
				Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
			}
		},
		{ passive: !1 }
	)
})()

function isStorageSupported(type) {
	// Return false if we are in an iframe without access to sessionStorage
	if (window.self !== window.top) {
		return false
	}

	const testKey = "beyours:test"
	let storage
	if (type === "session") {
		storage = window.sessionStorage
	}
	if (type === "local") {
		storage = window.localStorage
	}

	try {
		storage.setItem(testKey, "1")
		storage.removeItem(testKey)
		return true
	} catch (error) {
		// Do nothing, this may happen in Safari in incognito mode
		return false
	}
}

function checkScrollbar() {
	const rect = document.body.getBoundingClientRect()
	return Math.round(rect.left + rect.right) < window.innerWidth
}

function setScrollbarWidth() {
	if (checkScrollbar()) {
		const element = document.createElement("span")
		;(element.className = "modal-scrollbar-measure"), document.body.appendChild(element)

		const width = element.getBoundingClientRect().width - element.clientWidth
		document.body.removeChild(element)
		document.documentElement.style.setProperty("--scrollbar-width", `${width}px`)
	}
}

function setHeaderHeight() {
	const header = document.getElementById("shopify-section-header")
	if (header) {
		document.documentElement.style.setProperty(
			"--header-height",
			`${parseInt(header.getBoundingClientRect().bottom)}px`
		)
	}
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	)
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	removeTrapFocus()

	trapFocusHandlers.focusin = event => {
		var elements = getFocusableElements(container)
		var first = elements[0]
		var last = elements[elements.length - 1]

		if (event.target !== container && event.target !== last && event.target !== first) return

		document.addEventListener("keydown", trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code && event.code.toUpperCase() !== "TAB") return // If not TAB key

		var elements = getFocusableElements(container)
		var first = elements[0]
		var last = elements[elements.length - 1]

		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener("focusout", trapFocusHandlers.focusout)
	document.addEventListener("focusin", trapFocusHandlers.focusin)

	if (elementToFocus) elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible")
} catch {
	focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN",
	]
	let currentFocusedElement = null
	let mouseClick = null

	window.addEventListener("keydown", event => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false
		}
	})

	window.addEventListener("mousedown", event => {
		mouseClick = true
	})

	window.addEventListener(
		"focus",
		() => {
			if (currentFocusedElement) currentFocusedElement.classList.remove("focused")

			if (mouseClick) return

			currentFocusedElement = document.activeElement
			currentFocusedElement.classList.add("focused")
		},
		true
	)
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach(video => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		)
	})
	document.querySelectorAll(".js-vimeo").forEach(video => {
		video.contentWindow.postMessage('{"method":"pause"}', "*")
	})
	document.querySelectorAll("video").forEach(video => video.pause())
	document.querySelectorAll("product-model").forEach(model => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin)
	document.removeEventListener("focusout", trapFocusHandlers.focusout)
	document.removeEventListener("keydown", trapFocusHandlers.keydown)

	if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return

	const openDetailsElement = event.target.closest("details[open]")
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector("summary")
	openDetailsElement.removeAttribute("open")
	summaryElement.setAttribute("aria-expanded", false)
	summaryElement.focus()
}

function filterShopifyEvent(event, domElement, callback) {
	let executeCallback = false
	if (event.type.includes("shopify:section")) {
		if (
			domElement.hasAttribute("data-section-id") &&
			domElement.getAttribute("data-section-id") === event.detail.sectionId
		) {
			executeCallback = true
		}
	} else if (event.type.includes("shopify:block") && event.target === domElement) {
		executeCallback = true
	}
	if (executeCallback) {
		callback(event)
	}
}

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: { "Content-Type": "application/json", Accept: `application/${type}` },
	}
}

const serializeForm = form => {
	const obj = {}
	const formData = new FormData(form)

	for (const key of formData.keys()) {
		const regex = /(?:^(properties\[))(.*?)(?:\]$)/

		if (regex.test(key)) {
			obj.properties = obj.properties || {}
			obj.properties[regex.exec(key)[2]] = formData.get(key)
		} else {
			obj[key] = formData.get(key)
		}
	}

	return JSON.stringify(obj)
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options["method"] || "post"
	var params = options["parameters"] || {}

	var form = document.createElement("form")
	form.setAttribute("method", method)
	form.setAttribute("action", path)

	for (var key in params) {
		var hiddenField = document.createElement("input")
		hiddenField.setAttribute("type", "hidden")
		hiddenField.setAttribute("name", key)
		hiddenField.setAttribute("value", params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(options["hideElement"] || province_domid)

	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this))

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default")
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default")
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute("data-provinces")
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none"
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option")
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ""
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option")
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()

		this.init()
	}

	init() {
		this.input = this.querySelector("input")
		this.changeEvent = new Event("change", { bubbles: true })

		this.querySelectorAll("button").forEach(button =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		)
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
	}
}
customElements.define("quantity-input", QuantityInput)

class MenuDropdown extends HTMLElement {
	constructor() {
		super()

		this.classes = {
			isActive: "is-active",
		}

		this.addEventListener("focusin", this.openDropdown.bind(this))
		this.addEventListener("focusout", this.closeDropdown.bind(this))
		this.addEventListener("mouseover", this.openDropdown.bind(this))
		this.addEventListener("mouseleave", this.closeDropdown.bind(this))
	}

	openDropdown() {
		this.classList.add(this.classes.isActive)
	}

	closeDropdown() {
		this.classList.remove(this.classes.isActive)
	}
}
customElements.define("menu-dropdown", MenuDropdown)

class MenuDrawer extends HTMLElement {
	constructor(props) {
		super()

		this.classes = props
			? props.classes
			: {
					open: "menu-drawer--open",
					opening: "menu-drawer--opening",
					closing: "menu-drawer--closing",
			  }

		this.mainDetailsToggle = this.querySelector("details")

		this.addEventListener("keyup", this.onKeyUp.bind(this))
		this.addEventListener("focusout", this.onFocusOut.bind(this))
		this.bindEvents()
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach(summary =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		)
		this.querySelectorAll("button").forEach(button =>
			button.addEventListener("click", this.onCloseButtonClick.bind(this))
		)
	}

	onKeyUp(event) {
		if (event.code && event.code.toUpperCase() !== "ESCAPE") return

		const openDetailsElement = event.target.closest("details[open]")
		if (!openDetailsElement) return

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
			: this.closeSubmenu(openDetailsElement)
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget
		const detailsElement = summaryElement.parentNode
		const isOpen = detailsElement.hasAttribute("open")
		const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")

		function addTrapFocus() {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"))
			summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus)
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault()
			isOpen
				? this.closeMenuDrawer(event, summaryElement)
				: this.openMenuDrawer(summaryElement)
		} else {
			setTimeout(() => {
				detailsElement.classList.add("menu-opening")
				//summaryElement.setAttribute("aria-expanded", true) 
				summaryElement.removeAttribute("aria-expanded")
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener(
							"transitionend",
							addTrapFocus
					  )
			}, 100)
		}
	}

	openMenuDrawer(summaryElement) {
		setHeaderHeight()
		setScrollbarWidth()
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening")
		})
		summaryElement.removeAttribute("aria-expanded")
		trapFocus(this.mainDetailsToggle, summaryElement)

		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
		document.body.addEventListener("click", this.onBodyClickEvent)
		document.body.classList.add(this.classes.opening)

		this.openAnimation()
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
				details.removeAttribute("open")
				details.classList.remove("menu-opening")
			})
			this.mainDetailsToggle.classList.remove("menu-opening")
			this.mainDetailsToggle.classList.add("menu-closing")
			const mainSummary = this.mainDetailsToggle.querySelector("summary")
			if (mainSummary) mainSummary.removeAttribute("aria-expanded")
			removeTrapFocus(elementToFocus)

			document.body.removeEventListener("click", this.onBodyClickEvent)
			document.body.classList.remove(this.classes.open)
			document.body.classList.add(this.classes.closing)

			this.closeAnimation(this.mainDetailsToggle)
			this.dispatchEvent(new CustomEvent("close"))
		}
	}

	onFocusOut() {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer()
		})
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details")
		this.closeSubmenu(detailsElement)
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove("menu-opening")
		//detailsElement.querySelector("summary").setAttribute("aria-expanded", false)
		removeTrapFocus()
		this.closeAnimation(detailsElement)
	}

	openAnimation() {
		let animationStart

		const handleAnimation = time => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				document.body.classList.remove(this.classes.opening)
				document.body.classList.add(this.classes.open)
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}

	closeAnimation(detailsElement) {
		let animationStart

		const handleAnimation = time => {
			if (animationStart === undefined) {
				animationStart = time
			}

			const elapsedTime = time - animationStart

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation)
			} else {
				if (detailsElement === this.mainDetailsToggle) {
					document.body.classList.remove(this.classes.closing)
					detailsElement.classList.remove("menu-closing")
				}
				detailsElement.removeAttribute("open")

				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					)
				}
			}
		}

		window.requestAnimationFrame(handleAnimation)
	}

	onBodyClick(event) {
		if (!this.contains(event.target)) this.closeMenuDrawer(event)
	}
}
customElements.define("menu-drawer", MenuDrawer)

class CartDrawer extends MenuDrawer {
	constructor() {
		super({
			classes: {
				open: "mini-cart--open",
				opening: "mini-cart--opening",
				closing: "mini-cart--closing",
			},
		})
	}
}
customElements.define("cart-drawer", CartDrawer)

class AccountDrawer extends MenuDrawer {
	constructor() {
		super({
			classes: {
				open: "account-drawer--open",
				opening: "account-drawer--opening",
				closing: "account-drawer--closing",
			},
		})
	}
}
customElements.define("account-drawer", AccountDrawer)

class FacetDrawer extends MenuDrawer {
	constructor() {
		super({
			classes: {
				open: "facet-drawer--open",
				opening: "facet-drawer--opening",
				closing: "facet-drawer--closing",
			},
		})
	}
}
customElements.define("facet-drawer", FacetDrawer)

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super({
			classes: {
				open: "menu-mobile--open",
				opening: "menu-mobile--opening",
				closing: "menu-mobile--closing",
			},
		})
	}
}
customElements.define("header-drawer", HeaderDrawer)

class ModalDialog extends HTMLElement {
	constructor() {
		super()

		this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this))
		this.addEventListener("keyup", event => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide()
		})
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", event => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide()
			})
		} else {
			this.addEventListener("click", event => {
				if (event.target.nodeName === "MODAL-DIALOG") this.hide()
			})
		}
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector(".template-popup")
		document.body.classList.add("overflow-hidden")
		this.setAttribute("open", "")
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()
	}

	hide() {
		document.body.classList.remove("overflow-hidden")
		this.removeAttribute("open")
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()
	}
}
customElements.define("modal-dialog", ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		this.button = this.querySelector("button")
		if (!this.button) return

		this.button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"))
			if (modal) modal.show(this.button)
		})
	}
}
customElements.define("modal-opener", ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()

		this.poster = this.querySelector('[id^="Deferred-Poster-"]')
		if (!this.poster) return

		this.poster.addEventListener("click", this.loadContent.bind(this))
	}

	loadContent() {
		window.pauseAllMedia()
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div")
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(true)
			)

			this.setAttribute("loaded", true)
			this.appendChild(content.querySelector("video, model-viewer, iframe")).focus()
		}
	}
}
customElements.define("deferred-media", DeferredMedia)

class SliderComponent extends HTMLElement {
	constructor() {
		super()

		this.slider = this.querySelector('[id^="Slider-"]')
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
		this.enableSliderLooping = false
		this.currentPageElement = this.querySelector(".slider-counter--current")
		this.pageTotalElement = this.querySelector(".slider-counter--total")
		this.prevButton = this.querySelector('button[name="previous"]')
		this.nextButton = this.querySelector('button[name="next"]')

		if (!this.slider || !this.nextButton) return

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 200,
		})
	}

	init() {
		const resizeObserver = new ResizeObserver(() => this.initPages())
		resizeObserver.observe(this.slider)

		this.slider.addEventListener("scroll", this.update.bind(this))
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this))
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this))
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter(
			element => element.clientWidth > 0
		)
		if (this.sliderItemsToShow.length < 2) return
		this.sliderItemOffset =
			this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
		this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset)
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
		this.update()
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
		this.initPages()
	}

	update() {
		const previousPage = this.currentPage
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage
			this.pageTotalElement.textContent = this.totalPages
		}

		if (this.currentPage != previousPage) {
			this.dispatchEvent(
				new CustomEvent("slideChanged", {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1],
					},
				})
			)
		}

		if (this.currentPage === 1 && this.currentPage === this.totalPages) {
			this.classList.add("slider--no-buttons")
		} else {
			this.classList.remove("slider--no-buttons")
		}

		if (this.enableSliderLooping) return

		const isFirstSlide = this.currentPage === 1
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length

		if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
			this.prevButton.setAttribute("disabled", "disabled")
		} else {
			this.prevButton.removeAttribute("disabled")
		}

		if (
			isLastSlide ||
			this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
		) {
			this.nextButton.setAttribute("disabled", "disabled")
		} else {
			this.nextButton.removeAttribute("disabled")
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset
		return (
			element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
			element.offsetLeft >= this.slider.scrollLeft
		)
	}

	onButtonClick(event) {
		event.preventDefault()

		const step = event.currentTarget.dataset.step || 1
		this.slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset
		this.slideScrollPosition = theme.config.rtl
			? this.slideScrollPosition * -1
			: this.slideScrollPosition
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		})
	}
}
customElements.define("slider-component", SliderComponent)

class ThumbnailSlider extends SliderComponent {
	constructor() {
		super()
	}

	init() {
		super.init()

		const variantItems = this.querySelectorAll(".thumbnail-list_item--variant:not(.is-active)")
		this.slider.dataset.mediaCount = this.sliderItems.length - variantItems.length

		if (this.querySelector("[data-gang-option]")) {
			const inactiveGangItems = this.querySelectorAll("[data-gang-option]:not(.gang__active)")
			this.slider.dataset.mediaCount = this.sliderItems.length - inactiveGangItems.length
		}

		if (this.slider.dataset.mediaCount < 2) this.classList.add("hidden")
	}
}
customElements.define("thumbnail-slider", ThumbnailSlider)

class QuoteSlider extends SliderComponent {
	constructor() {
		super()
	}

	update() {
		super.update()

		if (this.currentPageElement && this.pageTotalElement) {
			this.sliderItems.forEach(element => {
				element.removeAttribute("aria-current")
			})

			const currentElement = this.sliderItemsToShow[this.currentPage - 1]
			currentElement.setAttribute("aria-current", true)
		}
	}
}
customElements.define("quote-slider", QuoteSlider)

class ProductGallery extends SliderComponent {
	constructor() {
		super()
	}

	init() {
		super.init()

		const gallerySliderButtons = this.querySelector(".slider-buttons")
		if (gallerySliderButtons && this.querySelector("[data-gang-option]")) {
			if (this.querySelectorAll(".product__media-item.gang__active").length < 2) {
				gallerySliderButtons.classList.add("hidden")
			} else {
				gallerySliderButtons.classList.remove("hidden")
			}
		}

		this.cursor = this.querySelector(".gallery-cursor")
		if (!this.cursor) return

		const images = this.querySelectorAll(".product__modal-opener--image")
		images.forEach(image => image.addEventListener("mousemove", this.onMoveHandler.bind(this)))
		images.forEach(image =>
			image.addEventListener("mouseenter", this.onEnterHandler.bind(this))
		)
		images.forEach(image =>
			image.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
		)
	}

	onMoveHandler(event) {
		this.cursor.style.left = `${event.clientX - 32}px`
		this.cursor.style.top = `${event.clientY - 32}px`
	}

	onEnterHandler() {
		this.cursor.classList.add("show")
	}

	onLeaveHandler() {
		this.cursor.classList.remove("show")
	}

	update() {
		super.update()

		if (this.currentPageElement && this.pageTotalElement) {
			const currentElement = this.sliderItemsToShow[this.currentPage - 1]
			if (currentElement) {
				this.slider.style.setProperty(
					"--force-image-ratio-percent",
					currentElement
						.querySelector(".media")
						.style.getPropertyValue("--image-ratio-percent")
				)
			}
		}
	}
}
customElements.define("product-gallery", ProductGallery)

class VariantSelects extends HTMLElement {
	constructor() {
		super()

		this.addEventListener("change", this.onVariantChange)
	}

	onVariantChange(event) {
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, "", false)
		this.updatePickupAvailability()
		this.removeErrorMessage()
		this.validateGang()

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true)
			this.setUnavailable()
		} else {
			if (this.gangOption) {
				this.updateGangMedia()
			} else {
				this.updateMedia()
			}
			this.updateURL()
			this.updateVariantInput()
			this.renderProductInfo()
		}

		this.handleStickyCart(event.target)
	}

	handleStickyCart(target) {
		const stickyCart = document.getElementById(`sticky-cart-${this.dataset.section}`)
		if (!stickyCart) return

		const attribute = target.getAttribute("name")

		document
			.querySelectorAll(
				`variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`
			)
			.forEach(input => {
				if (input.tagName === "INPUT") {
					input.checked = input.value === target.value
				} else {
					input.value = target.value
				}
			})

		if (!this.currentVariant) return
		if (!this.currentVariant.featured_media) return

		const image = document.querySelector(".sticky-cart__content-image img")
		if (image) {
			image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`
			image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`
			image.width = 70
			image.height = Math.ceil(
				70 / this.currentVariant.featured_media.preview_image.aspect_ratio
			)
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll("select"), select => select.value)
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find(variant => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option
				})
				.includes(false)
		})
	}

	validateGang() {
		const mediaItemWithGang = document.querySelector(
			`#shopify-section-${this.dataset.section} [data-gang-option]`
		)
		if (mediaItemWithGang) {
			this.gangOption = mediaItemWithGang.dataset.gangOption
		}
	}

	updateGangMedia() {
		if (!this.gangOption) return

		const variantInputWrapper = this.querySelector(
			'.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]'
		)
		if (variantInputWrapper) {
			this.gangIndex = variantInputWrapper.dataset.optionIndex
		} else {
			this.gangOption = null
		}

		if (!this.currentVariant) return
		//if (!this.currentVariant.featured_media) return;

		const gangValue = this.getSlug(this.currentVariant[this.gangIndex])
		if (this.currentGangValue === gangValue) {
			return
		}

		document
			.querySelectorAll(`#shopify-section-${this.dataset.section} [data-gang-connect]`)
			.forEach(function (media) {
				media.classList.remove("gang__active")
			})

		this.currentGangValue = gangValue
		var gangConnect = this.gangOption + "_" + gangValue
		const newMedias = document.querySelectorAll(
			`#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"]`
		)

		if (!newMedias.length) return
		Array.from(newMedias)
			.reverse()
			.forEach(function (newMedia) {
				newMedia.classList.add("gang__active")
				let parent = newMedia.parentElement
				if (parent.firstChild != newMedia) {
					parent.prepend(newMedia)
					parent.classList.add("product__media-no-animate")
				}
			})

		const thumbnailSlider = document.getElementById(`GalleryThumbnails-${this.dataset.section}`)
		if (thumbnailSlider) {
			const inactiveItems = thumbnailSlider.querySelectorAll(
				".thumbnail-list__item:not(.gang__active)"
			)
			thumbnailSlider.slider.dataset.mediaCount =
				thumbnailSlider.sliderItems.length - inactiveItems.length
			if (thumbnailSlider.slider.dataset.mediaCount < 2) {
				thumbnailSlider.classList.add("hidden")
			} else {
				thumbnailSlider.classList.remove("hidden")
			}
			thumbnailSlider.resetPages()
		}

		const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`)
		if (!mediaGallery) {
			const productGallery = document.querySelector(
				`#shopify-section-${this.dataset.section} product-gallery`
			)
			if (productGallery) {
				productGallery.resetPages()
			}
		}

		const gallerySliderButtons = document.querySelector(
			`#shopify-section-${this.dataset.section} product-gallery .slider-buttons`
		)
		if (gallerySliderButtons) {
			if (
				document.querySelectorAll(
					`#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active`
				).length < 2
			) {
				gallerySliderButtons.classList.add("hidden")
			} else {
				gallerySliderButtons.classList.remove("hidden")
			}
		}

		if (!this.currentVariant.featured_media) return

		if (mediaGallery) {
			const scrollIntoView = typeof this.dataset.noScroll === "undefined"
			mediaGallery.setActiveMedia(
				`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				true,
				scrollIntoView
			)
		}

		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`
		)
		if (modalContent) {
			const newMediaModal = modalContent.querySelector(
				`[data-media-id="${this.currentVariant.featured_media.id}"]`
			)
			modalContent.prepend(newMediaModal)
		}

		const thumbnailContent = document.querySelector(
			`#ProductThumbnails-${this.dataset.section}`
		)
		if (thumbnailContent) {
			const newMediaThumbnail = thumbnailContent.querySelector(
				`[data-media-id="${this.currentVariant.featured_media.id}"]`
			)
			thumbnailContent.prepend(newMediaThumbnail)
		}
	}

	getSlug(someString) {
		return someString
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, "-")
			.replace(/-$/, "")
			.replace(/^-/, "")
	}

	updateMedia() {
		if (!this.currentVariant) return
		if (!this.currentVariant.featured_media) return
		const newMedia = document.querySelector(
			`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
		)

		if (!newMedia) return

		const parent = newMedia.parentElement
		if (parent.firstChild == newMedia) return
		parent.prepend(newMedia)
		parent.classList.add("product__media-no-animate")

		const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`)
		if (mediaGallery) {
			const scrollIntoView = typeof this.dataset.noScroll === "undefined"
			mediaGallery.setActiveMedia(
				`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				true,
				scrollIntoView
			)
		}

		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`
		)
		if (modalContent) {
			const newMediaModal = modalContent.querySelector(
				`[data-media-id="${this.currentVariant.featured_media.id}"]`
			)
			modalContent.prepend(newMediaModal)
		}

		const thumbnailContent = document.querySelector(
			`#ProductThumbnails-${this.dataset.section}`
		)
		if (thumbnailContent) {
			const newMediaThumbnail = thumbnailContent.querySelector(
				`[data-media-id="${this.currentVariant.featured_media.id}"]`
			)
			thumbnailContent.prepend(newMediaThumbnail)
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`)
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment, #product-form-${this.dataset.section}--alt`
		)
		productForms.forEach(productForm => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event("change", { bubbles: true }))
		})
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability")
		if (!pickUpAvailability) return

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id)
		} else {
			pickUpAvailability.removeAttribute("available")
			pickUpAvailability.innerHTML = ""
		}
	}

	removeErrorMessage() {
		const section = this.closest("section")
		if (!section) return

		const productForm = section.querySelector("product-form")
		if (productForm) productForm.handleErrorMessage()
	}

	renderProductInfo() {
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
		)
			.then(response => response.text())
			.then(responseText => {
				this.updateSKU(responseText)
				this.updatePrice(responseText)
				this.updatePriceAlt(responseText)
				this.updateColorName(responseText)
				this.updateInventoryStatus(responseText)
				if (this.currentVariant)
					this.toggleAddButton(!this.currentVariant.available, variantStrings.soldOut)
			})
			.catch(e => {
				console.error(e)
			})
	}

	updateSKU(responseText) {
		const id = `sku-${this.dataset.section}`
		const html = new DOMParser().parseFromString(responseText, "text/html")
		const destination = document.getElementById(id)
		const source = html.getElementById(id)

		if (source && destination) destination.innerHTML = source.innerHTML
		if (destination) destination.classList.remove("visibility-hidden")
	}

	updatePrice(responseText) {
		const id = `price-${this.dataset.section}`
		const html = new DOMParser().parseFromString(responseText, "text/html")
		const destination = document.getElementById(id)
		const source = html.getElementById(id)

		if (source && destination) destination.innerHTML = source.innerHTML
		if (destination) destination.classList.remove("visibility-hidden")
	}

	updatePriceAlt(responseText) {
		const id = `price-${this.dataset.section}--alt`
		const html = new DOMParser().parseFromString(responseText, "text/html")
		const destination = document.getElementById(id)
		const source = html.getElementById(id)

		if (source && destination) destination.innerHTML = source.innerHTML
		if (destination) destination.classList.remove("visibility-hidden")
	}

	updateColorName(responseText) {
		const id = `color-${this.dataset.section}`
		const html = new DOMParser().parseFromString(responseText, "text/html")
		const destination = document.getElementById(id)
		const source = html.getElementById(id)

		if (source && destination) destination.innerHTML = source.innerHTML
		if (destination) destination.classList.remove("visibility-hidden")
	}

	updateInventoryStatus(responseText) {
		const id = `inventory-${this.dataset.section}`
		const html = new DOMParser().parseFromString(responseText, "text/html")
		const destination = document.getElementById(id)
		const source = html.getElementById(id)

		if (source && destination) destination.innerHTML = source.innerHTML
		if (destination) destination.classList.remove("visibility-hidden")
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`
		)
		productForms.forEach(productForm => {
			const addButton = productForm.querySelector('[name="add"]')
			if (!addButton) return

			if (disable) {
				addButton.setAttribute("disabled", true)
				if (text) addButton.textContent = text
			} else {
				addButton.removeAttribute("disabled")
				addButton.textContent =
					addButton.dataset.preOrder === "true"
						? variantStrings.preOrder
						: variantStrings.addToCart
			}

			if (!modifyClass) return
		})
	}

	setUnavailable() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`
		)
		productForms.forEach(productForm => {
			const addButton = productForm.querySelector('[name="add"]')
			if (!addButton) return
			addButton.textContent = variantStrings.unavailable

			const price = document.getElementById(`price-${this.dataset.section}`)
			if (price) price.classList.add("visibility-hidden")

			const priceAlt = document.getElementById(`price-${this.dataset.section}--alt`)
			if (priceAlt) priceAlt.classList.add("visibility-hidden")

			const inventory = document.getElementById(`inventory-${this.dataset.section}`)
			if (inventory) inventory.classList.add("visibility-hidden")
		})
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}
customElements.define("variant-selects", VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll("fieldset"))
		this.options = fieldsets.map(fieldset => {
			return Array.from(fieldset.querySelectorAll("input")).find(radio => radio.checked).value
		})
	}
}
customElements.define("variant-radios", VariantRadios)

class ProductForm extends HTMLElement {
	constructor() {
		super()

		this.miniCart = document.querySelector("mini-cart")
		this.form = this.querySelector("form")
		this.form.querySelector("[name=id]").disabled = false
		this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
	}

	onSubmitHandler(evt) {
		if (document.body.classList.contains("template-cart")) {
			return
		}

		evt.preventDefault()
		const submitButton = this.querySelector('[type="submit"]')
		if (submitButton.classList.contains("loading")) {
			return
		}

		this.handleErrorMessage()

		submitButton.setAttribute("aria-disabled", true)
		submitButton.classList.add("loading")

		const config = fetchConfig("javascript")
		config.headers["X-Requested-With"] = "XMLHttpRequest"
		delete config.headers["Content-Type"]

		const formData = new FormData(this.form)

		if (this.miniCart) {
			formData.append(
				"sections",
				this.miniCart.getSectionsToRender().map(section => section.id)
			)
		}
		formData.append("sections_url", window.location.pathname)
		config.body = formData

		fetch(`${routes.cart_add_url}`, config)
			.then(response => response.json())
			.then(parsedState => {
				if (parsedState.status) {
					this.handleErrorMessage(parsedState.description)
					return
				}

				if (this.miniCart) {
					this.miniCart.renderContents(parsedState)
				}
			})
			.catch(e => {
				console.error(e)
			})
			.finally(() => {
				submitButton.classList.remove("loading")
				submitButton.removeAttribute("aria-disabled")
			})
	}

	handleErrorMessage(errorMessage = false) {
		this.errorMessageWrapper =
			this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")

		if (this.errorMessageWrapper) {
			this.errorMessage =
				this.errorMessage ||
				this.errorMessageWrapper.querySelector(".product-form__error-message")
			this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage
			}
		} else {
			if (errorMessage) {
				alert(errorMessage)
			}
		}
	}
}
customElements.define("product-form", ProductForm)

class ProgressBar extends HTMLElement {
	constructor() {
		super()

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 0,
		})
	}

	init() {
		setTimeout(() => {
			const quantity = parseInt(this.dataset.quantity)
			this.style.setProperty("--progress-bar-width", `${(quantity * 100) / 30}%`)
		}, 1e3)
	}
}
customElements.define("progress-bar", ProgressBar)

class FormState extends HTMLElement {
	constructor() {
		super()

		this.formInputs = this.querySelectorAll("input,select,textarea")
		this.form = this.querySelector("form")

		this.formInputs.forEach(input => {
			input.addEventListener("input", this.onInputChange.bind(this))
			input.addEventListener("blur", this.onInputChange.bind(this))
		})

		if (this.form) this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
	}

	onInputChange(event) {
		this.handleInputCheck(event.target)
	}

	onSubmitHandler(event) {
		let valid = !0

		this.formInputs.forEach(input => {
			if (!this.handleInputCheck(input)) {
				valid = !1
			}
		})

		if (!valid) {
			event.preventDefault()
			return
		}
	}

	handleInputCheck(input) {
		if (input.classList.contains("required")) {
			if (input.value.length === 0 || input.value === input.dataset.empty) {
				input.classList.remove("valid")
				input.classList.add("invalid")

				return !1
			} else {
				input.classList.remove("invalid")
				input.classList.add("valid")

				return !0
			}
		}

		return !0
	}
}
customElements.define("form-state", FormState)

class ListMenuItem extends HTMLElement {
	constructor() {
		super()

		this.listMenuHover = this.closest("menu-drawer").querySelector("list-menu-hover")

		this.addEventListener("mouseenter", () => {
			this.listMenuHover.open({
				title: this.dataset.title,
				url: this.dataset.url,
				image: this.dataset.image,
				description: this.dataset.description,
			})
		})
	}
}
customElements.define("list-menu-item", ListMenuItem)

class ListMenuHover extends HTMLElement {
	constructor() {
		super()
	}

	open(obj) {
		let html = ""
		const opened = obj.image.length > 0 || obj.description.length > 0

		if (opened) {
			html += `<a href="${obj.url}" class="hover-collection${
				obj.image.length > 0 ? "" : " hover-collection--no-image"
			}">`
			html +=
				'<figure class="hover-collection__image"' +
				(obj.image.length > 0 ? `style="background-image:url(${obj.image})"` : "") +
				"></figure>"
			html += '<div class="hover-collection__content">'
			html += `<span class="hover-collection__title h4">${obj.title}</span>`
			html +=
				obj.description.length > 0
					? `<div class="hover-collection__description">${obj.description}</div>`
					: ""
			html += "</div>"
			html += "</a>"
		}

		this.innerHTML = html
	}

	close() {
		this.innerHTML = ""
	}
}
customElements.define("list-menu-hover", ListMenuHover)

class TransparentHeader extends HTMLElement {
	constructor() {
		super()

		const header = document.getElementById("shopify-section-header")

		header.classList.add("transparent-header")
		if (this.dataset.showSeparator == "true") {
			header.classList.add("transparent-separator")
		}
	}
}
customElements.define("transparent-header", TransparentHeader)

class ColorSwatch extends HTMLElement {
	constructor() {
		super()

		this.addEventListener("mouseenter", this.onHoverHandler.bind(this))
	}

	onHoverHandler() {
		const image = this.closest(".card-wrapper").querySelector(".media img")

		if (image !== null) {
			image.src = this.dataset.src
			image.srcset = this.dataset.srcset

			this.activeColorSwatch()
		}
	}

	activeColorSwatch() {
		this.closest(".card__colors")
			.querySelectorAll(".color-swatch")
			.forEach(color => {
				color.classList.remove("active")
			})

		this.parentNode.classList.add("active")
	}
}
customElements.define("color-swatch", ColorSwatch)

class AddToCart extends HTMLElement {
	constructor() {
		super()

		this.miniCart = document.querySelector("mini-cart")
		this.addEventListener("click", this.onClickHandler.bind(this))
	}

	onClickHandler() {
		const variantId = this.dataset.variantId

		if (variantId) {
			if (document.body.classList.contains("template-cart")) {
				Shopify.postLink(routes.cart_add_url, {
					parameters: {
						id: variantId,
						quantity: 1,
					},
				})
				return
			}

			this.setAttribute("disabled", true)
			this.classList.add("loading")
			const sections = this.miniCart
				? this.miniCart.getSectionsToRender().map(section => section.id)
				: []

			const body = JSON.stringify({
				id: variantId,
				quantity: 1,
				sections: sections,
				sections_url: window.location.pathname,
			})

			fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
				.then(response => response.json())
				.then(parsedState => {
					this.miniCart && this.miniCart.renderContents(parsedState)
				})
				.catch(e => {
					console.error(e)
				})
				.finally(() => {
					this.classList.remove("loading")
					this.removeAttribute("disabled")
				})
		}
	}
}
customElements.define("add-to-cart", AddToCart)

class PriceMoney extends HTMLElement {
	constructor() {
		super()

		this.init()
	}

	init() {
		const currencies_using_comma_decimals =
			"ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND".split(
				","
			)
		const symbol = shopSettings.moneyFormat.replace(/\{{.*}}/, "").trim()
		const bdi = this.querySelector("bdi")
		const price = bdi.textContent
		let html = price.replace(" ", "")
		let money_symbol_decimal = "."

		if (currencies_using_comma_decimals.includes(shopSettings.isoCode)) {
			money_symbol_decimal = ","
		}

		if (price.includes(money_symbol_decimal)) {
			if (price.lastIndexOf(symbol) + symbol.length === price.length) {
				const price_without_symbol = price.slice(0, price.lastIndexOf(symbol))
				const price_without_decimal = price.slice(
					0,
					price.lastIndexOf(money_symbol_decimal)
				)
				const decimal = price_without_symbol.replace(price_without_decimal, "").trim()
				// html = html.replace(decimal, `<sup>${decimal}</sup>`);
			} else {
				const price_without_decimal = price.slice(
					0,
					price.lastIndexOf(money_symbol_decimal)
				)
				const decimal = price.replace(price_without_decimal, "").trim()
				// html = html.replace(decimal, `<sup>${decimal}</sup>`);
			}
		}

		html = html.replace(symbol, `<span>${symbol}</span>`)

		bdi.innerHTML = html
	}
}
customElements.define("price-money", PriceMoney)

class SlideshowComponent extends HTMLElement {
	constructor() {
		super()

		this.mql = window.matchMedia("(min-width: 750px)")

		this.elements = {
			small: this.querySelector(".slideshow__left"),
			content: this.querySelector(".slideshow__content"),
			large: this.querySelector(".slideshow__right"),
		}
		this.settings = {
			autorotate: this.dataset.autorotate == "true",
			autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
			slidesSmall: this.elements.small.querySelectorAll(".slideshow__image"),
			slidesLarge: this.elements.large.querySelectorAll(".slideshow__image"),
		}

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 600,
		})
		this.matchMedia()
	}

	init() {
		setTimeout(() => {
			this.flickitySmall = new Flickity(this.elements.small, {
				accessibility: false,
				rightToLeft: theme.config.rtl,
				prevNextButtons: false,
				pageDots: false,
				wrapAround: true,
				draggable: false,
				setGallerySize: false,
				autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
			})

			this.flickityContent = new Flickity(this.elements.content, {
				accessibility: false,
				rightToLeft: theme.config.rtl,
				prevNextButtons: true,
				pageDots: true,
				wrapAround: true,
				draggable: this.mql.matches ? false : true,
				asNavFor: this.elements.small,
				adaptiveHeight: true,
				arrowShape:
					"M14.453 30.078q-0.391 1.172-3.125 16.602t-2.539 15.625 16.406 3.125 16.406 2.734 0.195-2.148l0.391-1.563-13.281-2.344q-13.281-2.344-13.281-2.734t2.734-2.344 5.078-3.125q3.906-2.734 9.18-4.688t10.352-2.734q3.516-0.391 8.789-0.391t8.789 0.391q15.625 2.344 28.125 13.281l3.125 2.344 1.563-1.172q1.172-1.172 1.172-1.563t-3.32-3.125-5.273-4.297q-5.078-3.125-11.133-5.664t-11.914-3.711q-3.906-0.781-10.938-0.781t-10.938 0.781q-6.25 1.172-13.281 4.297t-11.719 6.641q-1.563 1.563-1.758 1.367t1.758-12.305l2.344-12.109q0-0.391-1.953-0.781h-1.563q-0.391 0-0.391 0.391z",
				on: {
					ready: () => {
						const prevNextButtons = this.querySelectorAll(".flickity-button")
						if (prevNextButtons) {
							prevNextButtons.forEach(button => {
								button.setAttribute("tabindex", "-1")
							})
						}
					},
				},
			})

			this.flickityLarge = new Flickity(this.elements.large, {
				accessibility: false,
				rightToLeft: theme.config.rtl,
				prevNextButtons: false,
				pageDots: false,
				wrapAround: true,
				draggable: true,
				setGallerySize: false,
				asNavFor: this.elements.content,
			})

			this.bindEvents()
		})
	}

	bindEvents() {
		this.flickitySmall.on("scroll", () => {
			this.flickitySmall.slides.forEach((slide, i) => {
				const flickity = this.flickitySmall
				const image = this.settings.slidesSmall[i]
				let x = 0

				if (image) {
					if (0 === i) {
						x =
							Math.abs(flickity.x) > flickity.slidesWidth
								? flickity.slidesWidth +
								  flickity.x +
								  flickity.slides[flickity.slides.length - 1].outerWidth +
								  slide.target
								: slide.target + flickity.x
					} else if (i === flickity.slides.length - 1) {
						x =
							Math.abs(flickity.x) + flickity.slides[i].outerWidth <
							flickity.slidesWidth
								? slide.target -
								  flickity.slidesWidth +
								  flickity.x -
								  flickity.slides[i].outerWidth
								: slide.target + flickity.x
					} else {
						x = slide.target + flickity.x
					}

					if (!theme.config.isTouch && !theme.config.rtl) {
						image.style.transform = "translateX(" + x * (-1 / 2) + "px)"
					}
				}
			})
		})

		this.flickityLarge.on("scroll", () => {
			this.flickityLarge.slides.forEach((slide, i) => {
				const flickity = this.flickityLarge
				const image = this.settings.slidesLarge[i]
				let x = 0

				if (image) {
					if (0 === i) {
						x =
							Math.abs(flickity.x) > flickity.slidesWidth
								? flickity.slidesWidth +
								  flickity.x +
								  flickity.slides[flickity.slides.length - 1].outerWidth +
								  slide.target
								: slide.target + flickity.x
					} else if (i === flickity.slides.length - 1) {
						x =
							Math.abs(flickity.x) + flickity.slides[i].outerWidth <
							flickity.slidesWidth
								? slide.target -
								  flickity.slidesWidth +
								  flickity.x -
								  flickity.slides[i].outerWidth
								: slide.target + flickity.x
					} else {
						x = slide.target + flickity.x
					}

					if (!theme.config.isTouch && !theme.config.rtl) {
						image.style.transform = "translateX(" + x * (-1 / 2) + "px)"
					}
				}
			})
		})

		this.elements.content
			.querySelector(".flickity-button.next")
			.addEventListener("click", () => {
				this.flickitySmall.next()
				this.stopPlayer()
			})

		this.elements.content
			.querySelector(".flickity-button.previous")
			.addEventListener("click", () => {
				this.flickitySmall.previous()
				this.stopPlayer()
			})

		let currentIndex = null,
			swipeDirection = null

		// Detect swipe direction
		this.flickityLarge.on("dragMove", (_event, _pointer, moveVector) => {
			currentIndex = this.flickityLarge.selectedIndex
			swipeDirection = this.getSwipeDirection(moveVector)

			this.stopPlayer()
		})

		// Do stuff based on a successful swipe and it's direction
		this.flickityLarge.on("dragEnd", () => {
			if (this.flickityLarge.selectedIndex !== currentIndex) {
				if (swipeDirection === "left") {
					this.flickitySmall.next()
				} else {
					this.flickitySmall.previous()
				}
			}
		})
	}

	stopPlayer() {
		if (this.settings.autorotate) {
			this.flickitySmall.stopPlayer()
		}
	}

	getSwipeDirection(moveVector) {
		return moveVector.x > 0 ? "right" : "left"
	}

	matchMedia() {
		document.addEventListener("matchSmall", () => {
			this.unload()
			this.init()
		})

		document.addEventListener("unmatchSmall", () => {
			this.unload()
			this.init()
		})
	}

	unload() {
		if (this.flickitySmall && typeof this.flickitySmall.destroy === "function") {
			this.flickitySmall.destroy()
		}
		if (this.flickityContent && typeof this.flickityContent.destroy === "function") {
			this.flickityContent.destroy()
		}
		if (this.flickityLarge && typeof this.flickityLarge.destroy === "function") {
			this.flickityLarge.destroy()
		}
	}
}
customElements.define("slideshow-component", SlideshowComponent)


class StaticTestimonials extends HTMLElement {
  constructor() {
    super();
    this.rotateInterval = null;
  }

  connectedCallback() {
    // Cache elements
    this.autoRotate = this.getAttribute('auto-rotate') === "true";
    this.autoRotateSpeed = parseInt(this.getAttribute('auto-rotate-speed')) || 5000;
    this.previews = Array.from(this.querySelectorAll('.testimonials__static-preview'));
    this.navButtons = Array.from(this.querySelectorAll('.testimonials__static-navigation-button'));
    this.navBoxes = Array.from(this.querySelectorAll('.testimonials__static-navigation-box'));

    // Guard: nothing to do
    if (!this.previews.length || !this.navButtons.length) return;

    // Init state
    const initial = this.navBoxes.findIndex(b => b.classList.contains('active'));
    this.activeIndex = initial >= 0 ? initial : 0;
    this.applyActive(this.navButtons[this.activeIndex], this.activeIndex);

    // Add click listeners to buttons
    this.navButtons.forEach((button, idx) => {
      button.addEventListener('click', () => {
        this.applyActive(button, idx);
        // Reset auto-rotate timer when user clicks
        if (this.autoRotate) {
          this.stopAutoRotate();
          this.startAutoRotate();
        }
      });
    });

    // Start auto-rotate if enabled
    if (this.autoRotate) {
      this.startAutoRotate();

      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoRotate());
      this.addEventListener('mouseleave', () => this.startAutoRotate());
    }
  }

  startAutoRotate() {
    if (this.rotateInterval) return; // Already running

    this.rotateInterval = setInterval(() => {
      const nextIndex = (this.activeIndex + 1) % this.previews.length;
      this.applyActive(this.navButtons[nextIndex], nextIndex);
    }, this.autoRotateSpeed);
  }

  stopAutoRotate() {
    if (this.rotateInterval) {
      clearInterval(this.rotateInterval);
      this.rotateInterval = null;
    }
  }

  disconnectedCallback() {
    this.stopAutoRotate();
  }

  applyActive(button, index) {
    // Bounds check
    if (index < 0 || index >= this.previews.length) return;

    this.activeIndex = index;

    // Toggle button active state
    this.navButtons.forEach((btn) => {
      btn.classList.remove('active');
    });
    button.classList.add('active');

    // Toggle preview visibility
    this.previews.forEach((el, i) => {
      if (i === index) {
        el.classList.add('is-active');
        el.removeAttribute('hidden');
      } else {
        el.classList.remove('is-active');
        el.setAttribute('hidden', '');
      }
    });

    // Toggle nav active state
    this.navBoxes.forEach((box, i) => {
      if (i === index) {
        box.classList.add('active');
        box.setAttribute('aria-current', 'true');
      } else {
        box.classList.remove('active');
        box.removeAttribute('aria-current');
      }
    });
  }
}
customElements.define('static-testimonials', StaticTestimonials);

class TestimonialsComponent extends HTMLElement {
	constructor() {
		super()

		if (this.dataset.slider == "true") {
			this.settings = {
				autorotate: this.dataset.autorotate == "true",
				autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
			}
			this.slider = this.querySelector(".testimonial__list")
			this.previews = this.querySelector(".testimonial__previews")

			theme.initWhenVisible({
				element: this,
				callback: this.init.bind(this),
				threshold: 600,
			})
			theme.initWhenVisible({
				element: this,
				callback: this.update.bind(this),
				threshold: 0,
			})
		}
	}

	init() {
		setTimeout(() => {
			this.flickity = new Flickity(this.slider, {
				accessibility: false,
				rightToLeft: theme.config.rtl,
				prevNextButtons: true,
				arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
				pageDots: false,
				wrapAround: true,
				draggable: true,
				cellAlign: "center",
				autoPlay: this.settings.autorotate ? this.settings.autorotateSpeed : false,
				pauseAutoPlayOnHover: true,
				asNavFor: this.previews,
			})
			this.flickityNav = new Flickity(this.previews, {
				accessibility: false,
				rightToLeft: theme.config.rtl,
				prevNextButtons: false,
				pageDots: false,
				wrapAround: true,
				selectedAttraction: 0.2,
				friction: 0.8,
				adaptiveHeight: true,
			})

			this.flickityNav.previous()
			if (this.settings.autorotate) {
				this.flickity.pausePlayer()
			}

			this.flickity.on("staticClick", (_event, _pointer, _cellElement, cellIndex) => {
				if (typeof cellIndex == "number") {
					this.flickityNav.select(cellIndex)
				}
			})

			// Do stuff based on a successful swipe and it's direction
			this.flickity.on("change", index => {
				this.flickityNav.select(index)
			})
		})
	}

	update() {
		setTimeout(() => {
			if (this.flickity && this.flickityNav) {
				this.flickityNav.next()
				if (this.settings.autorotate) {
					this.flickity.unpausePlayer()
				}
			}
		}, 300)
	}

	getSwipeDirection(moveVector) {
		return moveVector.x > 0 ? "right" : "left"
	}
}
customElements.define("testimonials-component", TestimonialsComponent)

class UseAnimate extends HTMLElement {
	constructor() {
		super()

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 0,
		})
	}

	init() {
		this.setAttribute("animate", "")
	}
}
customElements.define("use-animate", UseAnimate)

class AnimateSticky extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.onScrollHandler = this.onScroll.bind(this)

		window.addEventListener("scroll", this.onScrollHandler, false)
		this.onScrollHandler()
	}

	disconnectedCallback() {
		window.removeEventListener("scroll", this.onScrollHandler)
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop

		if (scrollTop >= this.getOffsetTop(this)) {
			requestAnimationFrame(this.reveal.bind(this))
		} else {
			requestAnimationFrame(this.reset.bind(this))
		}
	}

	reveal() {
		this.setAttribute("animate", "")
	}

	reset() {
		this.removeAttribute("animate")
	}

	getOffsetTop(element) {
		let offsetTop = 0
		while (element) {
			offsetTop += element.offsetTop
			element = element.offsetParent
		}
		return offsetTop
	}
}
customElements.define("animate-sticky", AnimateSticky)

class LookbookComponent extends HTMLElement {
	constructor() {
		super()

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 0,
		})
	}

	init() {
		const hotspots = this.querySelectorAll(".look__hotspot")
		hotspots.forEach(hotspot => {
			hotspot.classList.add("active")
		})

		setTimeout(() => {
			hotspots.forEach(hotspot => {
				hotspot.classList.remove("active")
			})
		}, 3e3)
	}
}
customElements.define("lookbook-component", LookbookComponent)

class TabCollage extends HTMLElement {
	constructor() {
		super()

		this.tabs = Array.from(this.querySelectorAll('[role="tab"]'))
		this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'))
		this.cards = Array.from(this.querySelectorAll('.tab-collage__card'))

		this.tabs.forEach(tab => {
			tab.addEventListener("click", this.onTabClick.bind(this))
			tab.addEventListener("keydown", this.onTabKeydown.bind(this))
			tab.addEventListener("mouseover", this.onTabClick.bind(this))
		})
	}

	onTabClick(event) {
		const tab = event.currentTarget
		if (tab.classList.contains("active")) return
		this.selectTab(tab)
	}

	onTabKeydown(event) {
		const key = event.key
		let index = this.tabs.indexOf(event.currentTarget)

		if (key === "ArrowRight" || key === "ArrowDown") {
			event.preventDefault()
			index = (index + 1) % this.tabs.length
			this.selectTab(this.tabs[index])
			this.tabs[index].focus()
		} else if (key === "ArrowLeft" || key === "ArrowUp") {
			event.preventDefault()
			index = (index - 1 + this.tabs.length) % this.tabs.length
			this.selectTab(this.tabs[index])
			this.tabs[index].focus()
		} else if (key === "Home") {
			event.preventDefault()
			this.selectTab(this.tabs[0])
			this.tabs[0].focus()
		} else if (key === "End") {
			event.preventDefault()
			this.selectTab(this.tabs[this.tabs.length - 1])
			this.tabs[this.tabs.length - 1].focus()
		}
	}

	selectTab(selectedTab) {
		const blockId = selectedTab.dataset.blockId

		this.tabs.forEach(tab => {
			const isSelected = tab === selectedTab
			tab.setAttribute("aria-selected", isSelected)
			tab.setAttribute("tabindex", isSelected ? "0" : "-1")
			tab.classList.toggle("active", isSelected)
		})

		this.panels.forEach(panel => {
			const isActive = panel.dataset.blockId === blockId
			panel.classList.toggle("active", isActive)
			if (isActive) {
				panel.removeAttribute("hidden")
			} else {
				panel.setAttribute("hidden", "")
			}
		})

		this.cards.forEach(card => {
			card.classList.toggle("active", card.dataset.blockId === blockId)
		})
	}
}
customElements.define("tab-collage", TabCollage)

class CountdownTimer extends HTMLElement {
	constructor() {
		super()

		this.parent = this.closest(".product-countdown")
		this.date = new Date(Date.parse(this.dataset.date)).getTime()

		if (isNaN(this.date)) {
			this.unload()
			return
		}

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 200,
		})
	}

	init() {
		this.timer()
		this.dataset.interval = setInterval(this.timer.bind(this), 1000)
	}

	timer() {
		const now = new Date(),
			countTo = new Date(this.date),
			timeDifference = countTo - now

		if (timeDifference < 0) {
			this.unload()
			return
		}

		const secondsInADay = 60 * 60 * 1000 * 24,
			secondsInAHour = 60 * 60 * 1000

		const days = Math.floor((timeDifference / secondsInADay) * 1)
		const hours = Math.floor(((timeDifference % secondsInADay) / secondsInAHour) * 1)
		const mins = Math.floor(
			(((timeDifference % secondsInADay) % secondsInAHour) / (60 * 1000)) * 1
		)
		const secs = Math.floor(
			((((timeDifference % secondsInADay) % secondsInAHour) % (60 * 1000)) / 1000) * 1
		)

		if (this.dataset.compact == "true") {
			const dayHTML =
				days > 0
					? `<div class="countdown__item"><span>${days}${dateStrings.d}</span></div>`
					: ""
			const otherHTML = `<div class="countdown__item"><span>${
				hours > 9 ? hours : "0" + hours
			}:${mins > 9 ? mins : "0" + mins}:${secs > 9 ? secs : "0" + secs}</span></div>`

			this.innerHTML = dayHTML + otherHTML
		} else {
			const dayHTML =
				days > 0
					? `<div class="countdown__item"><span>${days}</span> ${
							days == 1 ? dateStrings.day : dateStrings.days
					  }</div>`
					: ""
			const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${
				hours == 1 ? dateStrings.hour : dateStrings.hours
			}</div>`
			const minHTML = `<div class="countdown__item"><span>${mins}</span> ${
				mins == 1 ? dateStrings.minute : dateStrings.minutes
			}</div>`
			const secHTML = `<div class="countdown__item"><span>${secs}</span> ${
				secs == 1 ? dateStrings.second : dateStrings.seconds
			}</div>`

			this.innerHTML = dayHTML + hourHTML + minHTML + secHTML
		}
	}

	unload() {
		if (this.dataset.interval) {
			clearInterval(this.dataset.interval)
		}

		this.classList.add("hidden")
		if (this.parent) {
			this.parent.classList.add("hidden")
		}
	}
}
customElements.define("countdown-timer", CountdownTimer)

class GMap extends HTMLElement {
	constructor() {
		super()

		if (!this.dataset.apiKey || !this.dataset.mapAddress) {
			return
		}

		theme.initWhenVisible({
			element: this,
			callback: this.prepMapApi.bind(this),
			threshold: 200,
		})
	}

	prepMapApi() {
		this.loadScript().then(this.initMap.bind(this))
	}

	loadScript() {
		return new Promise((resolve, reject) => {
			const script = document.createElement("script")
			document.body.appendChild(script)
			script.onload = resolve
			script.onerror = reject
			script.async = true
			script.src = "https://maps.googleapis.com/maps/api/js?key=" + this.dataset.apiKey
		})
	}

	initMap() {
		const geocoder = new google.maps.Geocoder()

		geocoder.geocode({ address: this.dataset.mapAddress }, (results, status) => {
			if (status !== google.maps.GeocoderStatus.OK) {
				if (Shopify.designMode) {
				}
			} else {
				const mapOptions = {
					zoom: parseInt(this.dataset.zoom),
					center: results[0].geometry.location,
					draggable: true,
					clickableIcons: false,
					scrollwheel: false,
					disableDoubleClickZoom: true,
					disableDefaultUI: true,
				}

				const map = new google.maps.Map(this, mapOptions),
					center = map.getCenter()

				map.setCenter(center)

				const icon = {
					path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
					fillColor: this.dataset.markerColor,
					fillOpacity: 1,
					anchor: new google.maps.Point(15, 55),
					strokeWeight: 0,
					scale: 0.6,
				}

				new google.maps.Marker({
					map: map,
					position: map.getCenter(),
					icon: icon,
				})

				const styledMapType = new google.maps.StyledMapType(
					JSON.parse(this.parentNode.querySelector("[data-gmap-style]").innerHTML)
				)

				map.mapTypes.set("styled_map", styledMapType)
				map.setMapTypeId("styled_map")

				google.maps.event.addDomListener(window, "resize", function () {
					google.maps.event.trigger(map, "resize")
					map.setCenter(center)
				})
			}
		})
	}
}
customElements.define("g-map", GMap)

class RelatedButtons extends HTMLElement {
	constructor() {
		super()

		window.addEventListener("scroll", this.checkListener.bind(this))
		this.querySelectorAll("a").forEach(button =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		)
	}

	checkListener() {
		const element = document.querySelector(this.dataset.scrollto)
		const show = window.scrollY >= element.offsetTop - element.clientHeight

		if (show) {
			this.classList.add("is-flipped")
		} else {
			this.classList.remove("is-flipped")
		}
	}

	onButtonClick(event) {
		event.preventDefault()
		const link = event.currentTarget
		const target = document.querySelector(link.getAttribute("href"))
		if (!target) return

		const focusTarget =
			target.id === "ProductImages"
				? document.querySelector("media-gallery") || target
				: target

		if (!focusTarget.hasAttribute("tabindex")) {
			focusTarget.setAttribute("tabindex", "-1")
		}

		target.scrollIntoView({ behavior: "smooth" })
		focusTarget.focus({ preventScroll: true })
	}
}
customElements.define("related-buttons", RelatedButtons)

class ProductRecentlyViewed extends HTMLElement {
	constructor() {
		super()

		// We save the product ID in local storage to be eventually used for recently viewed section
		if (isStorageSupported("local")) {
			const productId = parseInt(this.dataset.productId)
			const cookieName = "beyours:recently-viewed"
			const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]")

			// We check if the current product already exists, and if it does not, we add it at the start
			if (!items.includes(productId)) {
				items.unshift(productId)
			}

			// By keeping only the 4 most recent
			window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 5)))
		}
	}
}
customElements.define("product-recently-viewed", ProductRecentlyViewed)

class RecentlyViewedProducts extends HTMLElement {
	constructor() {
		super()

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 600,
		})
	}

	init() {
		fetch(this.dataset.url + this.getQueryString())
			.then(response => response.text())
			.then(text => {
				const html = document.createElement("div")
				html.innerHTML = text
				const recommendations = html.querySelector("recently-viewed-products")
				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML
				}
			})
			.catch(e => {
				console.error(e)
			})
	}

	getQueryString() {
		const cookieName = "beyours:recently-viewed"
		const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]")
		if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
			items.splice(items.indexOf(parseInt(this.dataset.productId)), 1)
		}
		return items
			.map(item => "id:" + item)
			.slice(0, 4)
			.join(" OR ")
	}
}
customElements.define("recently-viewed-products", RecentlyViewedProducts)

class VideoSection extends HTMLElement {
	constructor() {
		super()

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 600,
		})
	}

	init() {
		this.parent = this.closest(".media-wrapper")

		switch (this.dataset.type) {
			case "youtube":
				this.initYoutubeVideo()
				break

			case "vimeo":
				this.initVimeoVideo()
				break

			case "mp4":
				this.initMp4Video()
				break
		}
	}

	initYoutubeVideo() {
		this.setAsLoading()
		this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this))
	}

	initVimeoVideo() {
		this.setAsLoading()
		this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this))
	}

	initMp4Video() {
		const player = this.querySelector("video")

		if (player) {
			const promise = player.play()

			// Edge does not return a promise (video still plays)
			if (typeof promise !== "undefined") {
				promise
					.then(function () {
						// playback normal
					})
					.catch(function () {
						player.setAttribute("controls", "")
					})
			}
		}
	}

	loadScript(videoType) {
		return new Promise((resolve, reject) => {
			const script = document.createElement("script")
			document.body.appendChild(script)
			script.onload = resolve
			script.onerror = reject
			script.async = true
			script.src =
				videoType === "youtube"
					? "//www.youtube.com/iframe_api"
					: "//player.vimeo.com/api/player.js"
		})
	}

	setAsLoading() {
		this.parent.classList.add("loading")
	}

	setAsLoaded() {
		this.parent.classList.remove("loading")
	}

	setupYoutubePlayer() {
		const videoId = this.dataset.videoId

		const playerInterval = setInterval(() => {
			if (window.YT) {
				window.YT.ready(() => {
					this.player = new YT.Player(this.querySelector("div"), {
						videoId: videoId,
						playerVars: {
							showinfo: 0,
							controls: 0,
							fs: 0,
							rel: 0,
							height: "100%",
							width: "100%",
							iv_load_policy: 3,
							html5: 1,
							loop: 1,
							playsinline: 1,
							modestbranding: 1,
							disablekb: 1,
						},
						events: {
							onReady: this.onYoutubeReady.bind(this),
							onStateChange: this.onYoutubeStateChange.bind(this),
						},
					})
					clearInterval(playerInterval)
				})
			}
		}, 50)
	}

	onYoutubeReady() {
		this.iframe = this.querySelector("iframe") // iframe once YT loads
		this.iframe.setAttribute("tabindex", "-1")

		this.player.mute()
		this.player.playVideo()

		this.setAsLoaded()

		// pause when out of view
		var observer = new IntersectionObserver(
			(entries, _observer) => {
				entries.forEach(entry => {
					entry.isIntersecting ? this.youtubePlay() : this.youtubePause()
				})
			},
			{ rootMargin: "0px 0px 50px 0px" }
		)

		observer.observe(this.iframe)
	}

	onYoutubeStateChange(event) {
		switch (event.data) {
			case -1: // unstarted
				// Handle low power state on iOS by checking if
				// video is reset to unplayed after attempting to buffer
				if (this.attemptedToPlay) {
					this.setAsLoaded()
					this.closest(".banner").classList.add("video-interactable")
				}
				break
			case 0: // ended, loop it
				this.youtubePlay()
				break
			case 1: // playing
				this.setAsLoaded()
				break
			case 3: // buffering
				this.attemptedToPlay = true
				break
		}
	}

	youtubePlay() {
		if (this.player && typeof this.player.playVideo === "function") {
			this.player.playVideo()
		}
	}

	youtubePause() {
		if (this.player && typeof this.player.pauseVideo === "function") {
			this.player.pauseVideo()
		}
	}

	setupVimeoPlayer() {
		const videoId = this.dataset.videoId

		const playerInterval = setInterval(() => {
			if (window.Vimeo) {
				this.player = new Vimeo.Player(this, {
					id: videoId,
					autoplay: true,
					autopause: false,
					muted: true,
					background: true,
					loop: true,
					height: "100%",
					width: "100%",
				})
				this.player.ready().then(this.onVimeoReady.bind(this))

				clearInterval(playerInterval)
			}
		}, 50)
	}

	onVimeoReady() {
		this.iframe = this.querySelector("iframe")
		this.iframe.setAttribute("tabindex", "-1")

		this.player.setMuted(true)

		this.setAsLoaded()

		// pause when out of view
		var observer = new IntersectionObserver(
			(entries, _observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						this.vimeoPlay()
					} else {
						this.vimeoPause()
					}
				})
			},
			{ rootMargin: "0px 0px 50px 0px" }
		)

		observer.observe(this.iframe)
	}

	vimeoPlay() {
		if (this.player && typeof this.player.play === "function") {
			this.player.play()
		}
	}

	vimeoPause() {
		if (this.player && typeof this.player.pause === "function") {
			this.player.pause()
		}
	}
}

customElements.define("video-section", VideoSection)

window.onload = function () {
	const div = document.getElementById("load-menu")

	const URL = "https://waxcenter.com/pages/dynamic-header"

	fetch(URL)
		.then(function (response) {
			return response.text()
		})
		.then(html => {
			var replacing = true
			do {
				if (html.includes('href="/pages')) {
					html = html.replace('href="/pages', 'href="https://waxcenter.com/pages')
				} else {
					replacing = false
				}
			} while (replacing == true)

			replacing = true
			do {
				if (html.includes('href="/cart')) {
					html = html.replace('href="/cart', 'href="https://waxcenter.com/cart')
				} else {
					replacing = false
				}
			} while (replacing == true)

			replacing = true
			do {
				if (html.includes('href="/collections')) {
					html = html.replace(
						'href="/collections',
						'href="https://waxcenter.com/collections'
					)
				} else {
					replacing = false
				}
			} while (replacing == true)

			replacing = true
			do {
				if (html.includes('href="/blogs')) {
					html = html.replace('href="/blogs', 'href="https://waxcenter.com/blogs')
				} else {
					replacing = false
				}
			} while (replacing == true)

			replacing = true
			do {
				if (html.includes('href="/account')) {
					html = html.replace('href="/account', 'href="https://waxcenter.com/account')
				} else {
					replacing = false
				}
			} while (replacing == true)

			replacing = true
			do {
				if (html.includes("https://reservations.waxcenter.com")) {
					html = html.replace(
						"https://reservations.waxcenter.com/webstoreNew/user/signIn",
						"https://waxcenterstage.zenotistage.com/webstoreNew/user/signIn"
					)
				} else {
					replacing = false
				}
			} while (replacing == true)

			if (!!div) div.innerHTML = html

			// console.log(html);
		})
		.catch(err => console.log(err))
}



class SlideshowVideosComponent extends HTMLElement {
	constructor() {
		super()

		this.mql = window.matchMedia("(min-width: 750px)")

		this.elements = { 
			slides: this.querySelector(".slideshow__slides")
		}
		this.settings = {
			autorotate: this.dataset.autorotate == "true",
			autorotateSpeed: parseInt(this.dataset.autorotateSpeed), 
			slidesLarge: this.elements.slides.querySelectorAll(".slideshow__video"),
		}

		theme.initWhenVisible({
			element: this,
			callback: this.init.bind(this),
			threshold: 600,
		})
		this.matchMedia()
	}

	init() {
		setTimeout(() => { 
			
			if (this.mql.matches) { // only make it a slideshow if on a larger screen

				this.flickity = new Flickity(this.elements.slides, {  
					prevNextButtons: true,
					pageDots: false,
					wrapAround: true,
					draggable: true,    
					arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
					on: {
						ready: () => {
							const prevNextButtons = this.querySelectorAll(".flickity-button")
							if (prevNextButtons) {
								prevNextButtons.forEach(button => {
									button.setAttribute("tabindex", "-1")
								})
							}
						},
					},
				})

			}
 
		})
	}
 
	getSwipeDirection(moveVector) {
		return moveVector.x > 0 ? "right" : "left"
	}

	matchMedia() {
		document.addEventListener("matchSmall", () => {
			this.unload()
			this.init()
		})

		document.addEventListener("unmatchSmall", () => {
			this.unload()
			this.init()
		})
	}

	unload() { 
		if (this.flickity && typeof this.flickity.destroy === "function") {
			this.flickity.destroy()
		}
	}
}
customElements.define("slideshow-videos-component", SlideshowVideosComponent)